/**
 * Character entity schema
 */

import { z } from 'zod';

export const CharacterSchema = z.object({
  id: z.string(),
  world_id: z.string(),
  name: z.string(),
  is_player_character: z.boolean(),
  identity_summary: z.string().nullable(),
  physical_description: z.string().nullable(),
  role_in_story: z.string().nullable(),
  age: z.string().nullable(),
  background: z.string().nullable(),
  movement_quality: z.string().nullable(),
  primary_drive: z.string().nullable(),
  core_wound: z.string().nullable(),
  defense_mechanisms: z.array(z.string()).nullable(),
  blind_spots: z.array(z.string()).nullable(),
  intelligence_signature: z.string().nullable(),
  decision_architecture: z.string().nullable(),
  knowledge_domains: z.array(z.string()).nullable(),
  observable_habits: z.array(z.string()).nullable(),
  stress_response: z.string().nullable(),
  social_calibration: z.string().nullable(),
  speech_patterns: z.string().nullable(),
  canonical_dialogue_examples: z.array(z.string()).nullable(),
  vocabulary_tier: z.string().nullable(),
  speech_tempo: z.string().nullable(),
  emotional_baseline: z.string().nullable(),
  attachment_style: z.string().nullable(),
  power_orientation: z.string().nullable(),
  trust_calculus: z.string().nullable(),
  surface_goals: z.array(z.string()).nullable(),
  hidden_goals: z.array(z.string()).nullable(),
  current_location: z.string().nullable(),
  current_objective: z.string().nullable(),
  current_secrets: z.array(z.string()).nullable(),
  current_wounds: z.array(z.string()).nullable(),
  current_emotional_state: z.string().nullable(),
  active_concerns: z.array(z.string()).nullable(),
  defining_moment_ids: z.array(z.string()).nullable(),
  first_appearance_scene_id: z.string().nullable(),
  scene_count: z.number().int().nonnegative(),
  last_seen_turn: z.number().int().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  // Computed field: true if character is actively present in the current scene
  is_active: z.boolean().optional(),
});

export type Character = z.infer<typeof CharacterSchema>;
